import formsBackendClient from '@/tsClient/servers/noodleQuestionnaires';
import { type CreateDynamicPdfTemplateRequest } from '@/typings/questionnaires-api-models';

const createDynamicPdfTemplate = async (data: CreateDynamicPdfTemplateRequest): Promise<void> => {
  const response = await formsBackendClient.post('/dynamic-pdf-templates', data);
  return response.data;
};

export default createDynamicPdfTemplate;
